export const blankCommunicationFilters = () => ({
    communicationDateFrom: null,
    communicationDateTo: null,
    accountType: null,
    subject: null,
    createdDateFrom: null,
    createdDateTo: null,
    accountName: null,
    modifiedDateFrom: null,
    modifiedDateTo: null,
    type: null,
    assignedToId: null,
    active: true,
})

export const blankNoteFilters = () => ({
    subject: null,
    createdDateFrom: null,
    createdDateTo: null,
    modifiedDateFrom: null,
    modifiedDateTo: null,
    description: null,
    orderId: null,
    active: true,
})
